import { empProxy, empSearchProxy, configProxy } from './index';
// proxy/emp/1.0/
// proxy/emp/search/1.0/
// proxy/ncConfig/1.0

/* [ 임직원 관련 ] */
// 신규입사자 목록조회
function getNewMemberList() {
  return empProxy.get('user/new-emp/list');
}

// 직원검색 목록조회
function getMemberSearchList(params) {
  return empSearchProxy.get('mobile/list', { params });
}

// 직원프로필 선택항목조회
function getProfileOptionalCols() {
  return empSearchProxy.get('mobile/profile/cols');
}

// 임직원 목록조회 (결재>임직원찾기 모달용)
function getMemberList(params) {
  return configProxy.get('appCode/appEmp/list', { params });
}

export {
  getNewMemberList,
  getMemberSearchList,
  getProfileOptionalCols,
  getMemberList,
};
